import { ReactNode } from 'react';

type ColorVariants =
  | 'default'
  | 'decorative10'
  | 'decorative20'
  | 'decorative30'
  | 'decorative40';

export enum ProductIconName {
  Alarms = 'ProductAlarmsIcon',
  ApiExplorer = 'ProductAPIExplorerIcon',
  Assets = 'ProductAssetsIcon',
  Authy = 'ProductAuthyIcon',
  Conversations = 'ProductConversationsIcon',
  Connections = 'ProductConnectionsIcon',
  ElasticSipTrunking = 'ProductElasticSIPTrunkingIcon',
  EmailApi = 'ProductEmailAPIIcon',
  Fax = 'ProductFaxIcon',
  Flex = 'ProductFlexIcon',
  Functions = 'ProductFunctionsIcon',
  Frontline = 'ProductFrontlineIcon',
  InternetOfThings = 'ProductInternetOfThingsIcon',
  Lookup = 'ProductLookupIcon',
  MarketingCampaigns = 'ProductMarketingCampaignsIcon',
  Messaging = 'ProductMessagingIcon',
  Notify = 'ProductNotifyIcon',
  PhoneNumbers = 'ProductPhoneNumbersIcon',
  Privacy = 'ProductPrivacyIcon',
  Studio = 'ProductStudioIcon',
  Sync = 'ProductSyncIcon',
  TaskRouter = 'ProductTaskRouterIcon',
  Twilio = 'LogoTwilioIcon',
  Twiml = 'ProductTwiMLBinsIcon',
  TwilioOrg = 'ProductTwilioOrgIcon',
  Verify = 'ProductVerifyIcon',
  Video = 'ProductVideoIcon',
  Voice = 'ProductVoiceIcon',
}

// Add more options as needed
export interface LoaderOptions {
  childrenLoadersCount?: number;
}

// @todo - Redesign type def for `icon.name` after API integration
export interface ProductCardProps {
  articlesCount?: number;
  children?: ReactNode;
  heading?: string;
  height?: string | number | string[];
  icon?: ProductIcon;
  isLoading?: boolean;
  viewMoreOptions?: ViewMoreOptions;
}

export interface ProductIcon {
  color?: ColorVariants;
  name: ProductIconName;
}

export interface ViewMoreOptions {
  href: string;
  isVisible: boolean;
  trackEvent?: () => void;
}
